import {fabric} from 'fabric';
import DefaultSquare from '../nuclide/levelhelpers/DefaultSquare';
import RowColSquare from '../nuclide/levelhelpers/RowColSquare';
import SquareGrid from '../nuclide/levelhelpers/SquareGrid';

export default function createFour(nuclide) {
    let items = [];

    if(nuclide.isRow || nuclide.isColumn) {
        new RowColSquare(nuclide, items, 16, false);
    } else {
        new DefaultSquare(nuclide, items, 16);

        let grid = new SquareGrid(items, nuclide, 16);
        grid.createGrid(4);
    }

    let group = new fabric.Group(items, {
        objectCaching: false,
        opacity: nuclide.opacity
    });

    return group;
};